// extracted by mini-css-extract-plugin
export default {"tableRow":"AccessesTable_tableRow__duXj4","header":"AccessesTable_header__yRtYH","buttonHeader":"AccessesTable_buttonHeader__OC7DP"};